<p-steps [model]="pagineCreaSegnalazione" [readonly]="true" [activeIndex]="activeIndex" ></p-steps>
<div class="d-flex">
  <ng-container [ngSwitch]="activeIndex">
    <ng-container *ngSwitchCase="0">
      <form [formGroup]="creaSegnalazioneForm">
        <div class="grid formgrid p-fluid">
          <div class="field mt-2 mb-2 col-6">
              <label for="comune" class="font-medium text-900 text-blue-600">Comune</label>
                <p-dropdown *ngIf="!isSegnalatore"
                    [options]="comuni"
                    formControlName="comune"
                    (onChange)="onComuneSelect($event.value)"
                    optionLabel="denominazione"
                    [filter]="true"
                    filterBy="denominazione"
                    [showClear]="false"
                    placeholder="Seleziona un comune">
                </p-dropdown>

          </div>
          <div class="field mt-2 mb-2 col-6">
            <label for="segnalatore" class="font-medium text-900 text-bluegray-600" >Segnalatore</label>
            <span class="p-input-icon-left">
              <i class="pi pi-user-edit"></i>
              <input id="segnalatore" type="text" pInputText  formControlName="segnalatore">
            </span>
          </div>
        <div class="field mt-2 mb-2 col-6">
            <label for="areaCompetenza" class="font-medium text-900 text-green-600">Area di Competenza</label>
            <span class="p-input-icon-left">
              <i class="pi pi-warehouse"></i>
              <p-dropdown inputId="areaCompetenza" [options]="areeCompetenza" optionLabel="label" [showClear]="true"
                    placeholder="Scegli l'area di competenza" formControlName="areaCompetenza" (onChange)="onAreaCompetenzaSelect($event)">
                    <ng-template let-areaCompetenza pTemplate="item">
                        <div class="flex align-items-center">
                            <div>{{areaCompetenza.label | uppercase}}</div>
                        </div>
                    </ng-template>
                </p-dropdown> 
            </span>
        </div>
        <div class="field mt-2 mb-2 col-6">
            <label for="tipo" class="font-medium text-900 text-yellow-600">Tipo di Segnalazione</label>
            <span class="p-input-icon-left">
              <i class="pi pi-lightbulbr"></i>
              <p-dropdown inputId="tipo" [options]="tipiSegnalazione" optionLabel="label" [showClear]="true"
                    placeholder="Scegli il tipo di segnalazione" formControlName="tipo">
                    <ng-template let-tipo pTemplate="item">
                        <div class="flex align-items-center">
                            <div>{{tipo.label | uppercase}}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </span>
          </div>
          <div class="field mt-2 mb-2 col-12">
            <label for="descrizione" class="font-medium text-900 text-orange-100">Note</label>
            <span class="p-input-icon-left">
              <i class="pi pi-info-circle"></i>
              <textarea id="descrizione" rows="3" [autoResize]="true" formControlName="descrizione" pInputTextarea></textarea>
            </span>
          </div>
        </div>


      </form>
    </ng-container>
    <ng-container *ngSwitchCase="1">

      <div style="width: 100%; height:480px" class="mt-2">
        <app-localize-issue-activity-widget #siglocmap
          [controlsMyPosition]="false"
          [showSostegni]="showSostegni"
          [srcPosition]="mapPosition()"
          [comune]="selectedComune"
          [areaCompetenza]="creaSegnalazioneForm.get('areaCompetenza')?.value?.label"
          (onPositionUpdate)="updatePosition($event)">
        </app-localize-issue-activity-widget>
      </div>

    </ng-container>
    <ng-container *ngSwitchCase="2">
      <div class="grid mt-2 formgrid p-fluid">
        <div class="field mt-2 mb-2 col-12">
          <p class="line-height-3 p-0 m-0 mb-1 mt-1">
            Seleziona file da caricare o trascinalo nell'area sottostante
           </p>
           <p-fileUpload
           multiple="true"
           maxFileSize="5000000"
           accept=".JPEG, .PNG, .jpg, .jpeg, .png, .xls, .xlsx, .XLS, .XLSX, .pdf, .PDF"
           chooseLabel="Cerca" uploadLabel="Carica" cancelLabel="Cancella"
           [auto]="true"
           [customUpload]="true"
           (uploadHandler)="onFileUpload($event)"
           [showUploadButton]="false"
           [showCancelButton]="false"
           [disabled]="isSaving()"
           (onRemove)="onFileRemove()"
           >
         </p-fileUpload>
        </div>
      </div>

    </ng-container>
  </ng-container>
</div>
<div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
<div class="margin-bottom-1 d-flex justify-content-between">
  @if (activeIndex > 0) {
  <p-button icon="pi pi-arrow-left" class="p-button-text mr-2" (click)="changePage(-1)"
    [disabled]="isSaving()"></p-button>
  }
  @if (activeIndex < pagineCreaSegnalazione.length -1) {
  <p-button icon="pi pi-arrow-right" class="p-button-text mr-1" (click)="changePage(1)"
    [disabled]="checkNextStep()"></p-button>
  }

  @if (activeIndex === pagineCreaSegnalazione.length -1) {
  <p-button icon="pi pi-check" label="Conferma"
    class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [loading]="isSaving()"></p-button>
  }
</div>
